import React, { useState } from 'react';
import { GenericPopup, Button, ButtonTheme } from '@apply/components';

export const GenericPopupDemo: React.FC<{}> = ({}) => {
    const [isPopupOpen, set_isPopupOpen] = useState(false);

    const launchPopup = () => {
        set_isPopupOpen(true);
    };

    const handleCancel = () => set_isPopupOpen(false);

    const actionButtons = [
        { id: 'okButton', theme: ButtonTheme.Primary, disabled: false, children: 'OK', width: '200px' },
        { id: 'cancelButton', theme: ButtonTheme.Decline, disabled: false, children: 'Cancel', width: '200px' },
    ];

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Generic Popup Control :</h2>
            <br />
            <Button
                id='launchPopupDemoButton'
                theme={ButtonTheme.Primary}
                handleClick={launchPopup}
                width='300px'
            >
                Launch Popup
            </Button>
            <GenericPopup
                id='genericPopupDemo'
                isOpen={isPopupOpen}
                actionButtons={actionButtons}
                title='Generic Popup Demo'
                showTitle={true}
                showCloseButton={true}
                width='400px'
                height='200px'
                handleClose={handleCancel}
            >
                This is the popup.
            </GenericPopup>
        </div>
    );
};
